import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import APIS from "../../apis"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import cresusFond from "../../assets/images/prop1.png"
import { Grid } from "react-loader-spinner"
import axios from "axios"
import { toast } from "react-toastify"
const Score = props => {
  const [loading, setLoading] = useState(false)
  const [id, setId] = useState("")
  const [annee, setAnnee] = useState("")
  const [anneeName, setAnneeName] = useState("")
  const [score, setScore] = useState([])
  const [cin, setCin] = useState("")
  const [etat, setEtat] = useState(0)
  const [etatValide, setEtatValide] = useState(0)
  const [modal, setModal] = useState(false)
  useEffect(async () => {
    var url = window.location.href;
    var array = url.split("=");
    var id = array[1];
    var [candidatId, cin] = id.split("/");
    setId(candidatId)
    setCin(cin)
    const resScore = await APIS.post("master/candidat/get_score", {id: candidatId })
      .then(resScore => {
        setLoading(true)
        setScore(resScore.data.result.scores)
        setEtat(resScore.data.result.etat)
        setEtatValide(resScore.data.result.etat_candidature)
      }
    )
    const res = await axios
      .get("https://scolarite-migration.cresus-institut.ovh/api/annee/select")
      .then(res => {
        const resAnnee = axios
          .post(
            "https://scolarite-migration.cresus-institut.ovh/api/annee/get_by_id",
            { id: res.data.Annee[0].CurrentAnnee[0].value }
          )
          .then(resAnnee => {
            setAnnee(resAnnee.data.Annee.id)
            setAnneeName(resAnnee.data.Annee.annee_scolaire)
          })
      })
  }, [])

  const impr = () => {
    APIS.post("master/candidat/get_score", {id: id })
      .then(resScore => {
        setLoading(true)
        setScore(resScore.data.result.scores)
        setEtat(resScore.data.result.etat)
        setEtatValide(resScore.data.result.etat_candidature)
      })
    window.open('https://scolarite-migration.cresus-institut.ovh/api/master/candidat/' +id+"/pdf/"+ annee, '_blank')
  }
  const valider = () => {
       APIS.post("master/candidat/valider", {id: id })
      .then(res => {
        toast.success(" Votre demande a été mis avec succès",{ containerId: "A" });
        setLoading(true)
        APIS.post("master/candidat/get_score", {id: id })
          .then(resScore => {
            setModal(false)
            setLoading(true)
            setScore(resScore.data.result.scores)
            setEtat(resScore.data.result.etat)
            setEtatValide(resScore.data.result.etat_candidature)
          })
      })
  }
  const toggle = id => {
    setModal(!modal)
  }
  return (
    <div>
      {loading ? (
        <div
          style={{
            backgroundImage: `url(${cresusFond})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100vh",
            width: "auto",
          }}
        >
          <div style={{ paddingTop: "7%" }}>
            <Container>
              <Row className="justify-content-center">
                <Col md={12} lg={12} xl={12}>
                  <Card style={{ backgroundColor: "#dad8d8" }} className="overflow-hidden">
                    <div>
                      {" "}
                      <div>
                        <Row>
                          <Col className="justify-content-center pt-4">
                            <h1
                              style={{
                                color: "#3ba897",
                                textAlign: "center",
                              }}
                            >
                              <p>FICHE DES RENSEIGNEMENTS MASTERE</p>
                              <p>A.U {anneeName}</p>
                            </h1>
                          </Col>
                        </Row>
                      </div>
                      <Row>
                        <Col className="justify-content-center pt-4">
                        {score && score.length > 0 && (
                          <h4 style={{ lineHeight: "1.6" , textAlign: "center",}}>
                            Merci d’avoir finalisé votre inscription au concours
                            de <b>Master</b>. Vous avez choisi :{" "} <br/>
                            {score.map((item, i) => (
                              <span key={i}>
                              <b>{item.specialite_master}</b> ( Score {item.score})
                                {i < score.length - 1 ? " , " : "."} <br/>
                            </span>

                            ))}
                            <br />

                            Nous vous remercions pour votre confiance et vous
                            souhaitons bonne chance pour la suite du processus
                            d’admission.
                            <p style={{color:"red",fontSize:"12px"}}> {"Vous pouvez imprimer votre inscription puis la valider pour que votre inscription soit prise en compte avec succès."}</p>
                          </h4>

                        )}
                        </Col>
                      </Row>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <Col lg="12">
                          <div className="text-center mt-4">
                            <Button
                              type="button"
                              className="btn btn-secondary  mb-2 me-2"
                              onClick={impr}
                            >
                              Imprimer
                            </Button>
                            {etatValide == 0 ? (
                              <Button
                                onClick={() =>
                                  props.history.push("/EditIns?cin=" + cin)
                                }
                                type="button"
                                className="btn btn-success mb-2 me-2"
                              >
                                Modifier
                              </Button>
                            ):null}

                            {etat == 1 && etatValide == 0 ? (
                              <Button
                                type="button"
                                className="btn btn-danger mb-2 me-2"
                                onClick={toggle}
                              >
                                Valider
                              </Button>
                            ):null}

                          </div>
                        </Col>
                      </div>
                      <div className="mt-1 text-center">
                        <p>
                          © {new Date().getFullYear()} Cresus. Crafted with{" "}
                          <i className="mdi mdi-heart text-danger" /> by{" "}
                          <a href="https://cresus.pro/">cresus.pro</a>
                        </p>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      ) : (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-50px",
            marginLeft: "-50px",
          }}
        >
          <Grid heigth="100" width="100" color="#86B5E9" ariaLabel="loading" />
        </div>
      )}
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {"Validation d'inscription"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <h3 style={{color:"red"}}>Attention : cette action est irréversible</h3>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Êtes-vous sûr(e) de vouloir valider cette inscription ?</p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={valider}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                 OUI
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggle}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  NON
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default withRouter(Score)

Score.propTypes = {
  history: PropTypes.object,

}
